import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  es: {
    nav: {
      home: "Inicio",
      about: "Quiénes Somos",
      services: "Nuestras Soluciones",
      sustainability: "Sostenibilidad",
      sectors: "Experiencia por Industria",
      training: "Talento Humano",
      news: "Noticias",
      contact: "Contacto",
      admin: "Admin"
    },
    footer: {
      tagline: "Liderando la estructuración de proyectos estratégicos y la transformación organizacional en Latinoamérica.",
      quickLinks: "Enlaces Rápidos",
      contact: "Contacto",
      follow: "Síguenos",
      rights: "© 2025 Consulting Logistic, S.A. Todos los derechos reservados.",
      location: "Ciudad de Guatemala, Guatemala"
    },
    home: {
      heroTitle: "Transformamos Ideas en Inversiones con Impacto",
      heroSubtitle: "Lideramos la estructuración y ejecución de proyectos estratégicos integrando sostenibilidad, finanzas y tecnología en cada iniciativa.",
      servicesBtn: "Ver Soluciones",
      contactBtn: "Contáctanos",
      serviceAreaTitle: "Nuestras Capacidades Estratégicas",
      serviceAreaSubtitle: "Soluciones integrales diseñadas para potenciar el crecimiento y la eficiencia de tu organización",
      purposeTitle: "Negocios con Propósito",
      purposeText1: "En Consulting Logistic creemos en una forma de hacer negocios con propósito, integrando la sostenibilidad y los estándares ESG en cada iniciativa.",
      purposeText2: "Nuestro enfoque multisectorial y el liderazgo femenino que nos caracteriza nos permite ofrecer soluciones innovadoras y sostenibles para los desafíos más complejos.",
      learnMoreBtn: "Conoce Más",
      ctaTitle: "¿Listo para Transformar tu Proyecto?",
      ctaSubtitle: "Conecta con nuestro equipo de expertos y descubre cómo podemos ayudarte a alcanzar tus objetivos",
      scheduleBtn: "Agenda una Consulta",
      services: {
        investment: "Mesa de Inversión",
        investmentDesc: "Estructuración financiera y búsqueda de capital para proyectos.",
        digital: "Transformación Digital & Ops",
        digitalDesc: "Optimización de procesos y adopción tecnológica inteligente.",
        talent: "Talento Humano & Cultura",
        talentDesc: "Potenciamos el capital humano con LMS y Pulse360.",
        structuring: "Estructuración Técnica",
        structuringDesc: "Ingeniería avanzada y diseño estratégico integral."
      }
    },
    about: {
      title: "Quiénes Somos",
      subtitle: "Una firma latinoamericana líder que redefine la consultoría estratégica a través de la innovación y la sostenibilidad",
      historyTitle: "Nuestra Historia",
      historyText1: "Nacemos de la visión de transformar ideas en inversiones sólidas, integrando ingeniería, finanzas, tecnología y gestión estratégica en una sola visión de impacto.",
      historyText2: "Nuestra firma está liderada por un equipo multidisciplinario de mujeres con amplia trayectoria, aportando una visión pragmática y comprometida con el desarrollo regional.",
      historyText3: "Con más de 20 años de experiencia técnica respaldando proyectos por más de USD 1,200 millones, somos el aliado estratégico para empresas, inversionistas y gobiernos.",
      historyText4: "Trabajamos día a día para construir un futuro más sostenible y próspero para Latinoamérica, basándonos en la excelencia y el compromiso social.",
      teamTitle: "Nuestro Equipo Líder",
      teamSubtitle: "Conoce a las profesionales que, con su visión y experiencia, impulsan cada uno de nuestros proyectos hacia el éxito.",
      values: {
        mission: "Misión",
        missionDesc: "Transformar ideas en inversiones sostenibles mediante consultoría estratégica de clase mundial.",
        vision: "Visión",
        visionDesc: "Ser la firma líder en Latinoamérica en estructuración de proyectos con impacto sostenible.",
        excellence: "Excelencia",
        excellenceDesc: "Compromiso con los más altos estándares de calidad y profesionalismo en cada proyecto.",
        collaboration: "Colaboración",
        collaborationDesc: "Trabajo en equipo y alianzas estratégicas para maximizar el valor de cada iniciativa."
      },
      team: {
        member1: {
          title: "CEO",
          credentials: "Ingeniera Industrial | MBA | Especialista en Gestión",
          bio: "Lidera proyectos estratégicos en los sectores energético, industrial, inmobiliario y de servicios, con enfoque en eficiencia operativa, innovación tecnológica y sostenibilidad."
        },
        member2: {
          title: "",
          credentials: "Ejecutiva Senior en Dirección Estratégica",
          bio: "Con más de 25 años de experiencia en estructuración de negocios y gestión de inversiones. Ha gestionado con éxito inversiones y financiamientos internacionales."
        },
        member3: {
          title: "",
          credentials: "Abogada y facilitadora senior",
          bio: "Experta en liderazgo, comunicación estratégica y negociación. Ha trabajado con gobiernos y organismos internacionales en más de 20 países."
        },
        member4: {
          title: "",
          credentials: "Administración de Empresas",
          bio: "Lidera estrategias para la atracción de inversión y expansión comercial. Combina visión financiera y estratégica para posicionar organizaciones."
        },
        member5: {
          title: "",
          credentials: "Abogada especialista en finanzas",
          bio: "Trayectoria en el sector financiero y de inversión internacional. Lidera proyectos de banca de inversión y estructuración de deuda."
        }
      }
    },
    services: {
      title: "Nuestras Soluciones",
      subtitle: "Capacidades transversales diseñadas para transformar desafíos en oportunidades sostenibles",
      customTitle: "¿Necesitas una Solución Personalizada?",
      customSubtitle: "Cada proyecto es único. Nuestro equipo está listo para diseñar una estrategia a la medida de tus necesidades específicas.",
      learnMore: "Saber más",
      items: {
        investment: {
          title: "Mesa de Inversión y Estructuración Financiera",
          desc: "Conectamos capital privado, banca y cooperación internacional con proyectos de alto impacto, asegurando la viabilidad y rentabilidad a largo plazo.",
          features: [
            "Búsqueda de capital y financiamiento",
            "Modelación financiera y de riesgos",
            "Conexión con inversionistas estratégicos",
            "Estructuración de vehículos de inversión",
            "Due Diligence financiero y legal"
          ]
        },
        digital: {
          title: "Transformación Operativa e Inteligencia Digital",
          desc: "Optimizamos el ADN de tu organización mediante metodologías Lean y herramientas tecnológicas que impulsan la eficiencia y el uso de datos.",
          features: [
            "Rediseño y optimización de procesos (Lean)",
            "Automatización de flujo de trabajo",
            "Business Intelligence y Dashboards",
            "Estrategia de transformación digital",
            "Auditoría de eficiencia operativa"
          ]
        },
        talent: {
          title: "Talento Humano y Cultura Organizacional",
          desc: "Potenciamos el activo más valioso de tu empresa mediante nuestras plataformas exclusivas y consultoría de gestión de gente.",
          features: [
            "Hub CLAI HUB: Gestión de socios y networking",
            "LMS Pro: Plataforma de aprendizaje continuo",
            "Pulse360: Diagnóstico de clima y cultura",
            "Evaluaciones de desempeño y 360°",
            "Alineación de cultura y valores"
          ]
        },
        structuring: {
          title: "Estructuración Técnica de Infraestructura",
          desc: "Proporcionamos el respaldo técnico necesario para llevar proyectos de infraestructura y energía desde el concepto tras la ejecución real.",
          features: [
            "Ingeniería básica y de detalle",
            "Cumplimiento regulatorio y normativo",
            "Gestión ambiental y de riesgos",
            "Supervisión técnica de proyectos",
            "Estructuración de licitaciones (APPs)"
          ]
        }
      }
    },
    training: {
      title: "Talento Humano",
      subtitle: "Potenciando el desarrollo organizacional a través de capacitación estratégica y análisis del clima laboral",
      tab1: "Capacitación y Entrenamiento",
      tab2: "Clima Organizacional",
      tab3: "Hub CLAI HUB",
      hub: {
        title: "Hub CLAI HUB",
        subtitle: "La solución integral para la gestión, comunicación y networking de organizaciones empresariales.",
        introText: "Hub CLAI HUB es una plataforma diseñada específicamente para cámaras, asociaciones y federaciones. Su objetivo es transformar la relación con el socio, ofreciendo un entorno digital seguro y profesional para la interacción y el crecimiento colectivo.",
        featuresTitle: "Capacidades de la Plataforma",
        features: {
          members: {
            title: "Gestión de Socios",
            desc: "Administración eficiente del ciclo de vida del afiliado: altas, bajas, perfiles detallados y base de datos centralizada."
          },
          comm: {
            title: "Comunicación Ordenada",
            desc: "Un canal formal y estructurado para interactuar con asociados y socios, eliminando el ruido de plataformas informales."
          },
          networking: {
            title: "Networking Estratégico",
            desc: "Espacios dedicados para que los miembros conecten, compartan oportunidades y fortalezcan el ecosistema gremial."
          },
          finance: {
            title: "Transparencia Financiera",
            desc: "Consulta de estados de cuenta, gestión de cuotas y seguimiento administrativo transparente para cada socio."
          },
          lms: {
            title: "Capacitación (LMS)",
            desc: "Acceso integrado a la plataforma de aprendizaje para ofrecer formación continua como beneficio exclusivo."
          }
        },
        closingText: "Descubre cómo Hub CLAI HUB puede modernizar la gestión de tu organización y potenciar el valor para tus asociados.",
        contactBtn: "Solicitar Demo del Hub"
      },
      capacitacion: {
        introTitle: "Desarrollo Integral del Talento",
        introDesc: "Ofrecemos servicios especializados de reclutamiento estratégico y programas de capacitación diseñados para cerrar brechas de habilidades y preparar a los equipos para los desafíos del futuro.",
        programTitle: "Programa de Transformación Operativa y Adopción Digital",
        programSubtitle: "Una metodología integral estructurada en 9 fases clave para garantizar el éxito en la modernización de su empresa.",
        lmsTitle: "Plataforma LMS Demo",
        lmsDesc: "Explore nuestra plataforma de gestión del aprendizaje (LMS) diseñada para facilitar la capacitación continua y el seguimiento del progreso de sus colaboradores.",
        lmsBtn: "Ir a Demo LMS"
      },
      pulso360: {
        introText: "Consulting Logistic, en alianza estratégica con Asesoría Integral, anuncia el lanzamiento de Pulso360, una plataforma digital diseñada para medir, analizar y mejorar el clima organizacional de las empresas a partir de información clara, estructurada y accionable.",
        whatIsTitle: "¿Qué es Pulso360?",
        whatIsDesc: "Pulso360 es una herramienta integral de diagnóstico organizacional que permite a las empresas evaluar de manera objetiva y sistemática el ambiente laboral, identificar áreas de mejora y diseñar estrategias efectivas para fortalecer el compromiso, la productividad y el bienestar de sus colaboradores.",
        advantagesTitle: "Principales Ventajas",
        advantages: {
          agile: {
            title: "Implementación ágil",
            desc: "La herramienta se puede implementar en muy corto tiempo, lo que permite iniciar el proceso de evaluación sin demoras innecesarias."
          },
          confidential: {
            title: "Confidencialidad",
            desc: "Garantiza respuestas anónimas y seguras, fomentando la honestidad y confianza de los colaboradores."
          },
          vision: {
            title: "Visión 360°",
            desc: "Evalúa múltiples dimensiones del clima organizacional, proporcionando una perspectiva integral del ambiente laboral."
          },
          segmentation: {
            title: "Segmentación avanzada",
            desc: "Permite analizar resultados por departamento, ubicación, antigüedad u otras variables clave para tomar decisiones estratégicas."
          },
          comparable: {
            title: "Resultados comparables",
            desc: "Facilita benchmarking interno y externo para medir el progreso a lo largo del tiempo."
          }
        },
        reportsTitle: "Informes y Resultados",
        reports: {
          executive: {
            title: "Reporte ejecutivo general",
            desc: "Resumen de alto nivel con los hallazgos más relevantes."
          },
          detailed: {
            title: "Análisis detallado",
            desc: "Desglose por dimensiones evaluadas (liderazgo, comunicación, desarrollo profesional, etc.)."
          },
          visual: {
            title: "Indicadores visuales",
            desc: "Gráficos interactivos para facilitar la interpretación de datos."
          },
          findings: {
            title: "Hallazgos clave",
            desc: "Identificación de fortalezas y oportunidades de mejora."
          },
          export: {
            title: "Exportación de resultados",
            desc: "Formatos descargables para presentaciones ejecutivas."
          },
          foundation: {
            title: "Base sólida para planes de acción",
            desc: "Recomendaciones específicas para diseñar estrategias de mejora continua."
          }
        },
        closingText: "Pulso360 se posiciona como una solución estratégica para empresas que buscan no solo medir, sino transformar su cultura organizacional de manera sostenible. Es ideal para organizaciones comprometidas con el bienestar de su talento humano y la excelencia operacional.",
        contactBtn: "Contáctanos para más información"
      },
      phases: {
        p1: { title: "1. Diagnóstico y Alineación", desc: "Evaluación del estado actual de los procesos y capacidades digitales del equipo." },
        p2: { title: "2. Diseño de Estrategia", desc: "Definición de objetivos claros y KPIs para el proceso de transformación." },
        p3: { title: "3. Gestión del Cambio", desc: "Preparación cultural de la organización para adoptar nuevas formas de trabajo." },
        p4: { title: "4. Reclutamiento Especializado", desc: "Búsqueda y selección de perfiles clave necesarios para la nueva estructura." },
        p5: { title: "5. Capacitación Técnica", desc: "Formación en herramientas y competencias digitales específicas." },
        p6: { title: "6. Desarrollo de Habilidades Blandas", desc: "Fortalecimiento del liderazgo, comunicación y adaptabilidad." },
        p7: { title: "7. Implementación Piloto", desc: "Ejecución controlada de nuevas herramientas en áreas seleccionadas." },
        p8: { title: "8. Escalamiento y Adopción", desc: "Despliegue generalizado y acompañamiento continuo." },
        p9: { title: "9. Evaluación y Mejora Continua", desc: "Medición de impacto y ajustes para garantizar la sostenibilidad." }
      }
    },
    sectors: {
      title: "Experiencia por Industria",
      subtitle: "Profundo conocimiento sectorial que respalda la ejecución técnica de cada una de nuestras soluciones",
      experienceTitle: "Nuestra Trayectoria Sectorial",
      experienceDesc: "Contamos con una visión multisectorial que nos permite identificar riesgos y oportunidades específicas en cada mercado, garantizando soluciones pertinentes y duraderas.",
      integratedTitle: "Sinergia Multisectorial",
      integratedDesc1: "Aplicamos nuestras capacidades de Mesa de Inversión y Transformación Digital de manera transversal para potenciar el crecimiento en cada industria.",
      integratedDesc2: "Nuestra experiencia técnica nos permite hablar el lenguaje de cada sector, integrando estándares ESG y tecnología avanzada.",
      expertise: "Industrias Clave:",
      items: {
        energy: {
          title: "Energía & Minería",
          desc: "Respaldo técnico en cumplimiento regulatorio y gestión ambiental para proyectos renovables y de Oil & Gas."
        },
        realEstate: {
          title: "Desarrollo Inmobiliario & Urbano",
          desc: "Estructuración de proyectos comerciales, industriales y de vivienda con enfoque en rentabilidad y sostenibilidad."
        },
        infra: {
          title: "Infraestructura & Logística",
          desc: "Desarrollo de proyectos que impulsan la conectividad regional y la competitividad logística mediante estructuración sólida."
        },
        tourism: {
          title: "Turismo & Hospitalidad",
          desc: "Asesoría en el desarrollo de infraestructuras turísticas sostenibles que generan valor económico y social a largo plazo."
        },
        water: {
          title: "Gestión del Agua & Ambiente",
          desc: "Soluciones estratégicas para infraestructura hídrica y gestión responsable de recursos naturales y saneamiento."
        },
        tech: {
          title: "Tecnología & Servicios Globales",
          desc: "Acompañamiento a empresas digitales y de servicios en su expansión y optimización operativa a nivel regional."
        }
      }
    },
    sustainability: {
      title: "Sostenibilidad",
      subtitle: "Negocios con propósito: integrando sostenibilidad y estándares ESG en cada iniciativa",
      commitmentTitle: "Nuestro Compromiso ESG",
      commitmentText1: "En Consulting Logistic, la sostenibilidad no es solo una palabra de moda, es el núcleo de nuestra filosofía empresarial.",
      commitmentText2: "Integramos los criterios ESG (Environmental, Social, and Governance) en cada etapa de nuestros proyectos.",
      commitmentText3: "Nuestro enfoque holístico nos permite identificar oportunidades que no solo son rentables, sino que también contribuyen al bienestar.",
      pillarsTitle: "Pilares ESG",
      pillarsSubtitle: "Tres dimensiones fundamentales que guían nuestras decisiones y acciones",
      impactTitle: "Impacto Medible",
      impactText1: "Medimos y reportamos el impacto de nuestros proyectos utilizando métricas reconocidas internacionalmente.",
      impactText2: "Nuestro compromiso con la sostenibilidad se refleja en resultados concretos: reducción de emisiones, creación de empleo digno, desarrollo comunitario y gobernanza ética.",
      items: {
        environmental: {
          title: "Ambiental",
          desc: "Compromiso con la reducción de huella de carbono y promoción de energías renovables"
        },
        social: {
          title: "Social",
          desc: "Desarrollo comunitario y promoción de la equidad en todos nuestros proyectos"
        },
        governance: {
          title: "Gobernanza",
          desc: "Transparencia, ética y mejores prácticas en la gestión corporativa"
        },
        ods: {
          title: "Objetivos de Desarrollo Sostenible",
          desc: "Alineamos nuestros proyectos con los ODS de las Naciones Unidas"
        },
        circular: {
          title: "Economía Circular",
          desc: "Promovemos modelos de negocio que maximizan el uso de recursos"
        },
        positive: {
          title: "Impacto Social Positivo",
          desc: "Generamos valor compartido para todas las partes interesadas"
        }
      }
    },
    contact: {
      title: "Contacto",
      subtitle: "Estamos listos para ayudarte a transformar tus ideas en realidad",
      talkTitle: "Hablemos de tu Proyecto",
      talkDesc: "Completa el formulario y nuestro equipo se pondrá en contacto contigo en menos de 24 horas para discutir cómo podemos ayudarte.",
      form: {
        name: "Nombre Completo",
        email: "Email",
        company: "Empresa",
        phone: "Teléfono",
        message: "Mensaje",
        submit: "Enviar Mensaje",
        placeholderName: "Tu nombre",
        placeholderEmail: "tu@email.com",
        placeholderCompany: "Nombre de tu empresa",
        placeholderMsg: "Cuéntanos sobre tu proyecto..."
      },
      info: {
        email: "Email",
        phone: "Teléfono",
        office: "Oficina",
        hours: "Horario de Atención",
        hoursDesc: "Lunes a Viernes: 8:00 AM - 6:00 PM"
      }
    },
    news: {
      title: "Noticias e Insights",
      subtitle: "Análisis, tendencias y novedades sobre logística, energía e infraestructura en Latinoamérica.",
      heroSubtitle: "Perspectivas expertas sobre el desarrollo energético, inmobiliario y logístico en la región.",
      noNews: "No hay noticias publicadas en este momento.",
      readSource: "Leer fuente original",
      readArticle: "Leer artículo completo",
      writtenBy: "Escrito por",
      share: "Compartir",
      back: "Volver a noticias",
      interestedTitle: "¿Interesado en este tema?",
      interestedDesc: "Nuestro equipo de consultores expertos puede ayudarte a profundizar en estas estrategias para tu organización.",
      contactExpert: "Contactar a un Experto"
    },
    admin: {
      panelTitle: "Panel de Administración",
      logout: "Cerrar Sesión",
      loginTitle: "Iniciar Sesión Admin",
      registerTitle: "Registrar Admin",
      loginDesc: "Gestión de contenidos de Consulting Logistic",
      registerDesc: "Se requiere un código de invitación válido para crear una nueva cuenta administrativa.",
      email: "Email",
      password: "Contraseña",
      inviteCode: "Código de Invitación",
      loginBtn: "Ingresar",
      registerBtn: "Validar y Crear Cuenta",
      noAccount: "¿No tienes cuenta? Regístrate con código",
      hasAccount: "¿Ya tienes cuenta? Inicia sesión",
      tabs: {
        publish: "Publicar Noticia",
        settings: "Configuración de Datos",
        invitations: "Códigos de Invitación"
      },
      publish: {
        title: "Nueva Noticia",
        desc: "Complete el formulario para publicar un nuevo artículo en el sitio.",
        formTitle: "Título",
        slug: "Slug (URL)",
        category: "Categoría",
        image: "Imagen Destacada",
        excerpt: "Extracto (Resumen breve)",
        content: "Contenido (HTML soportado)",
        submit: "Publicar Artículo"
      }
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Our Solutions",
      sustainability: "Sustainability",
      sectors: "Industry Experience",
      training: "Human Talent",
      news: "News",
      contact: "Contact",
      admin: "Admin"
    },
    footer: {
      tagline: "Leading the structuring of strategic projects and organizational transformation in Latin America.",
      quickLinks: "Quick Links",
      contact: "Contact",
      follow: "Follow Us",
      rights: "© 2025 Consulting Logistic, S.A. All rights reserved.",
      location: "Guatemala City, Guatemala"
    },
    home: {
      heroTitle: "Transforming Ideas into Investments with Impact",
      heroSubtitle: "We lead the structuring and execution of strategic projects, integrating sustainability, finance, and technology into every initiative.",
      servicesBtn: "View Solutions",
      contactBtn: "Contact Us",
      serviceAreaTitle: "Our Strategic Capabilities",
      serviceAreaSubtitle: "Comprehensive solutions designed to drive your organization's growth and efficiency",
      purposeTitle: "Business with Purpose",
      purposeText1: "At Consulting Logistic, we believe in doing business with purpose, integrating sustainability and ESG standards into every initiative.",
      purposeText2: "Our multisectoral approach and characteristic female leadership allow us to offer innovative and sustainable solutions for the most complex challenges.",
      learnMoreBtn: "Learn More",
      ctaTitle: "Ready to Transform Your Project?",
      ctaSubtitle: "Connect with our team of experts and discover how we can help you achieve your goals",
      scheduleBtn: "Schedule a Consultation",
      services: {
        investment: "Investment Desk",
        investmentDesc: "Financial structuring and capital search for high-impact projects.",
        digital: "Digital & Ops Transformation",
        digitalDesc: "Process optimization and intelligent technology adoption.",
        talent: "Human Talent & Culture",
        talentDesc: "Empowering human capital with LMS and Pulse360.",
        structuring: "Technical Structuring",
        structuringDesc: "Advanced engineering and integral strategic design."
      }
    },
    about: {
      title: "About Us",
      subtitle: "A leading Latin American firm redefining strategic consulting through innovation and sustainability",
      historyTitle: "Our History",
      historyText1: "We were born from the vision of transforming ideas into solid investments, integration engineering, finance, and strategic management into a single vision of impact.",
      historyText2: "Our firm is led by a multidisciplinary team of women with extensive experience, bringing a pragmatic vision committed to regional development.",
      historyText3: "With over 20 years of technical expertise backing projects worth over USD 1.2 billion, we are the strategic ally for companies, investors, and governments.",
      historyText4: "We work every day to build a more sustainable and prosperous future for Latin America, based on excellence and social commitment.",
      teamTitle: "Our Leadership Team",
      teamSubtitle: "Meet the professionals who, with their vision and experience, drive each of our projects to success.",
      values: {
        mission: "Mission",
        missionDesc: "To transform ideas into sustainable investments through world-class strategic consulting.",
        vision: "Vision",
        visionDesc: "To be the leading firm in Latin America in structuring projects with sustainable impact.",
        excellence: "Excellence",
        excellenceDesc: "Commitment to the highest standards of quality and professionalism in every project.",
        collaboration: "Collaboration",
        collaborationDesc: "Teamwork and strategic alliances to maximize the value of every initiative."
      },
      team: {
        member1: {
          title: "CEO",
          credentials: "Industrial Engineer | MBA | Management Specialist",
          bio: "Leads strategic projects in the energy, industrial, real estate, and services sectors, focusing on operational efficiency, technological innovation, and sustainability."
        },
        member2: {
          title: "",
          credentials: "Senior Executive in Strategic Direction",
          bio: "With over 25 years of experience in business structuring and investment management. She has successfully managed international investments and financing."
        },
        member3: {
          title: "",
          credentials: "Lawyer and Senior Facilitator",
          bio: "Expert in leadership, strategic communication, and negotiation. She has worked with governments and international organizations in more than 20 countries."
        },
        member4: {
          title: "",
          credentials: "Business Administration",
          bio: "Leads strategies for investment attraction and commercial expansion. Combines financial and strategic vision to position organizations."
        },
        member5: {
          title: "",
          credentials: "Finance Specialist Lawyer",
          bio: "Track record in the financial and international investment sector. Leads investment banking and debt structuring projects."
        }
      }
    },
    services: {
      title: "Our Solutions",
      subtitle: "Cross-cutting capabilities designed to transform challenges into sustainable opportunities",
      customTitle: "Need a Personalized Solution?",
      customSubtitle: "Every project is unique. Our team is ready to design a strategy tailored to your specific needs.",
      learnMore: "Learn more",
      items: {
        investment: {
          title: "Investment Desk & Financial Structuring",
          desc: "We connect private capital, banking, and international cooperation with high-impact projects, ensuring long-term viability and profitability.",
          features: [
            "Capital search and financing",
            "Financial and risk modeling",
            "Connection with strategic investors",
            "Investment vehicle structuring",
            "Financial and legal Due Diligence"
          ]
        },
        digital: {
          title: "Operational Transformation & Digital Intelligence",
          desc: "We optimize your organization's DNA through Lean methodologies and technological tools that drive efficiency and data-driven decisions.",
          features: [
            "Process redesign and optimization (Lean)",
            "Workflow automation",
            "Business Intelligence and Dashboards",
            "Digital transformation strategy",
            "Operational efficiency auditing"
          ]
        },
        talent: {
          title: "Human Talent & Organizational Culture",
          desc: "We empower your company's most valuable asset through our exclusive platforms and people management consulting.",
          features: [
            "Hub CLAI HUB: Member management & networking",
            "LMS Pro: Continuous learning platform",
            "Pulse360: Climate & culture diagnostics",
            "Performance and 360° evaluations",
            "Culture and values alignment"
          ]
        },
        structuring: {
          title: "Technical Infrastructure Structuring",
          desc: "We provide the technical support needed to take infrastructure and energy projects from concept to real execution.",
          features: [
            "Basic and detailed engineering",
            "Regulatory and standards compliance",
            "Environmental and risk management",
            "Technical project supervision",
            "Tender structuring (PPPs)"
          ]
        }
      }
    },
    training: {
      title: "Human Talent",
      subtitle: "Empowering organizational development through strategic training and workplace climate analysis",
      tab1: "Training & Coaching",
      tab2: "Organizational Climate",
      tab3: "Hub CLAI HUB",
      hub: {
        title: "Hub CLAI HUB",
        subtitle: "Maximum management, communication, and networking for business organizations.",
        introText: "Hub CLAI HUB is a platform designed specifically for chambers, associations, and federations. Its goal is to transform the relationship with members, offering a secure and professional digital environment for interaction and collective growth.",
        featuresTitle: "Platform Capabilities",
        features: {
          members: {
            title: "Member Management",
            desc: "Efficient management of the affiliate lifecycle: joining, leaving, detailed profiles, and a centralized database."
          },
          comm: {
            title: "Orderly Communication",
            desc: "A formal and structured channel to interact with associates and partners, eliminating noise from informal platforms."
          },
          networking: {
            title: "Strategic Networking",
            desc: "Dedicated spaces for members to connect, share opportunities, and strengthen the trade ecosystem."
          },
          finance: {
            title: "Financial Transparency",
            desc: "Account status consultation, fee management, and transparent administrative tracking for each member."
          },
          lms: {
            title: "Learning (LMS)",
            desc: "Integrated access to the learning platform to offer continuous training as an exclusive benefit."
          }
        },
        closingText: "Discover how Hub CLAI HUB can modernize your organization's management and enhance value for your associates.",
        contactBtn: "Request Hub Demo"
      },
      capacitacion: {
        introTitle: "Comprehensive Talent Development",
        introDesc: "We offer specialized strategic recruitment services and training programs designed to bridge skill gaps and prepare teams for future challenges.",
        programTitle: "Operational Transformation & Digital Adoption Program",
        programSubtitle: "A comprehensive methodology structured in 9 key phases to ensure success in your company's modernization.",
        lmsTitle: "LMS Demo Platform",
        lmsDesc: "Explore our Learning Management System (LMS) designed to facilitate continuous training and track employee progress.",
        lmsBtn: "Go to LMS Demo"
      },
      pulso360: {
        introText: "Consulting Logistic, in strategic alliance with Asesoría Integral, announces the launch of Pulso360, a digital platform designed to measure, analyze, and improve the organizational climate of companies based on clear, structured, and actionable information.",
        whatIsTitle: "What is Pulso360?",
        whatIsDesc: "Pulso360 is a comprehensive organizational diagnostic tool that allows companies to objectively and systematically evaluate the work environment, identify areas for improvement, and design effective strategies to strengthen employee commitment, productivity, and well-being.",
        advantagesTitle: "Main Advantages",
        advantages: {
          agile: {
            title: "Agile Implementation",
            desc: "The tool can be implemented in a very short time, allowing the evaluation process to start without unnecessary delays."
          },
          confidential: {
            title: "Confidentiality",
            desc: "Guarantees anonymous and secure responses, fostering honesty and trust among employees."
          },
          vision: {
            title: "360° Vision",
            desc: "Evaluates multiple dimensions of organizational climate, providing a comprehensive perspective of the work environment."
          },
          segmentation: {
            title: "Advanced Segmentation",
            desc: "Allows analyzing results by department, location, seniority, or other key variables to make strategic decisions."
          },
          comparable: {
            title: "Comparable Results",
            desc: "Facilitates internal and external benchmarking to measure progress over time."
          }
        },
        reportsTitle: "Reports and Results",
        reports: {
          executive: {
            title: "General Executive Report",
            desc: "High-level summary with the most relevant findings."
          },
          detailed: {
            title: "Detailed Analysis",
            desc: "Breakdown by evaluated dimensions (leadership, communication, professional development, etc.)."
          },
          visual: {
            title: "Visual Indicators",
            desc: "Interactive charts to facilitate data interpretation."
          },
          findings: {
            title: "Key Findings",
            desc: "Identification of strengths and improvement opportunities."
          },
          export: {
            title: "Results Export",
            desc: "Downloadable formats for executive presentations."
          },
          foundation: {
            title: "Solid Foundation for Action Plans",
            desc: "Specific recommendations to design continuous improvement strategies."
          }
        },
        closingText: "Pulso360 positions itself as a strategic solution for companies looking not only to measure, but to transform their organizational culture in a sustainable way. It is ideal for organizations committed to the well-being of their human talent and operational excellence.",
        contactBtn: "Contact us for more information"
      },
      phases: {
        p1: { title: "1. Diagnosis & Alignment", desc: "Assessment of current processes and team digital capabilities." },
        p2: { title: "2. Strategy Design", desc: "Definition of clear objectives and KPIs for the transformation process." },
        p3: { title: "3. Change Management", desc: "Cultural preparation of the organization to adopt new ways of working." },
        p4: { title: "4. Specialized Recruitment", desc: "Search and selection of key profiles needed for the new structure." },
        p5: { title: "5. Technical Training", desc: "Training in specific digital tools and competencies." },
        p6: { title: "6. Soft Skills Development", desc: "Strengthening leadership, communication, and adaptability." },
        p7: { title: "7. Pilot Implementation", desc: "Controlled execution of new tools in selected areas." },
        p8: { title: "8. Scaling & Adoption", desc: "Widespread deployment and continuous support." },
        p9: { title: "9. Evaluation & Continuous Improvement", desc: "Impact measurement and adjustments to ensure sustainability." }
      }
    },
    sectors: {
      title: "Industry Experience",
      subtitle: "Deep sector knowledge supporting the technical execution of each of our solutions",
      experienceTitle: "Our Sector Track Record",
      experienceDesc: "We have a multisectoral vision that allows us to identify specific risks and opportunities in each market, ensuring relevant and lasting solutions.",
      integratedTitle: "Multisectoral Synergy",
      integratedDesc1: "We apply our Investment Desk and Digital Transformation capabilities transversally to drive growth in each industry.",
      integratedDesc2: "Our technical experience allows us to speak each sector's language, integrating ESG standards and advanced technology.",
      expertise: "Key Industries:",
      items: {
        energy: {
          title: "Energy & Mining",
          desc: "Technical support in regulatory compliance and environmental management for renewable and Oil & Gas projects."
        },
        realEstate: {
          title: "Real Estate & Urban Development",
          desc: "Structuring of commercial, industrial, and residential projects with a focus on profitability and sustainability."
        },
        infra: {
          title: "Infrastructure & Logistics",
          desc: "Development of projects that drive regional connectivity and logistical competitiveness through solid structuring."
        },
        tourism: {
          title: "Tourism & Hospitality",
          desc: "Advisory in the development of sustainable tourism infrastructure that generates long-term economic and social value."
        },
        water: {
          title: "Water & Environmental Management",
          desc: "Strategic solutions for water infrastructure and responsible management of natural resources and sanitation."
        },
        tech: {
          title: "Technology & Global Services",
          desc: "Support for digital and service companies in their expansion and operational optimization at a regional level."
        }
      }
    },
    sustainability: {
      title: "Sustainability",
      subtitle: "Business with purpose: integrating sustainability and ESG standards into every initiative",
      commitmentTitle: "Our ESG Commitment",
      commitmentText1: "At Consulting Logistic, sustainability is not just a buzzword; it is the core of our business philosophy.",
      commitmentText2: "We integrate ESG (Environmental, Social, and Governance) criteria into every stage of our projects.",
      commitmentText3: "Our holistic approach allows us to identify opportunities that are not only profitable but also contribute to well-being.",
      pillarsTitle: "ESG Pillars",
      pillarsSubtitle: "Three fundamental dimensions that guide our decisions and actions",
      impactTitle: "Measurable Impact",
      impactText1: "We measure and report the impact of our projects using internationally recognized metrics.",
      impactText2: "Our commitment to sustainability is reflected in concrete results: emission reduction, decent job creation, community development, and ethical governance.",
      items: {
        environmental: {
          title: "Environmental",
          desc: "Commitment to carbon footprint reduction and promotion of renewable energies"
        },
        social: {
          title: "Social",
          desc: "Community development and promotion of equity in all our projects"
        },
        governance: {
          title: "Governance",
          desc: "Transparency, ethics, and best practices in corporate management"
        },
        ods: {
          title: "Sustainable Development Goals",
          desc: "We align our projects with the UN SDGs"
        },
        circular: {
          title: "Circular Economy",
          desc: "We promote business models that maximize resource use"
        },
        positive: {
          title: "Positive Social Impact",
          desc: "We generate shared value for all stakeholders"
        }
      }
    },
    contact: {
      title: "Contact",
      subtitle: "We are ready to help you transform your ideas into reality",
      talkTitle: "Let's Talk About Your Project",
      talkDesc: "Complete the form and our team will contact you in less than 24 hours to discuss how we can help you.",
      form: {
        name: "Full Name",
        email: "Email",
        company: "Company",
        phone: "Phone",
        message: "Message",
        submit: "Send Message",
        placeholderName: "Your name",
        placeholderEmail: "you@email.com",
        placeholderCompany: "Your company name",
        placeholderMsg: "Tell us about your project..."
      },
      info: {
        email: "Email",
        phone: "Phone",
        office: "Office",
        hours: "Business Hours",
        hoursDesc: "Monday to Friday: 8:00 AM - 6:00 PM"
      }
    },
    news: {
      title: "News & Insights",
      subtitle: "Analysis, trends, and news on logistics, energy, and infrastructure in Latin America.",
      heroSubtitle: "Expert perspectives on energy, real estate, and logistics development in the region.",
      noNews: "There are no news published at this moment.",
      readSource: "Read original source",
      readArticle: "Read full article",
      writtenBy: "Written by",
      share: "Share",
      back: "Back to news",
      interestedTitle: "Interested in this topic?",
      interestedDesc: "Our team of expert consultants can help you deepen these strategies for your organization.",
      contactExpert: "Contact an Expert"
    },
    admin: {
      panelTitle: "Admin Panel",
      logout: "Log Out",
      loginTitle: "Admin Login",
      registerTitle: "Register Admin",
      loginDesc: "Consulting Logistic Content Management",
      registerDesc: "A valid invitation code is required to create a new administrative account.",
      email: "Email",
      password: "Password",
      inviteCode: "Invitation Code",
      loginBtn: "Login",
      registerBtn: "Validate & Create Account",
      noAccount: "No account? Register with code",
      hasAccount: "Already have an account? Login",
      tabs: {
        publish: "Publish News",
        settings: "Data Settings",
        invitations: "Invitation Codes"
      },
      publish: {
        title: "New Article",
        desc: "Complete the form to publish a new article on the site.",
        formTitle: "Title",
        slug: "Slug (URL)",
        category: "Category",
        image: "Featured Image",
        excerpt: "Excerpt (Brief summary)",
        content: "Content (HTML supported)",
        submit: "Publish Article"
      }
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  const t = (path) => {
    const keys = path.split('.');
    let value = translations[language];
    
    for (const key of keys) {
      if (value === undefined) return path;
      value = value[key];
    }
    
    return value || path;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};